/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type DoubleClickAction = {
  type: "double_click";
  x: number;
  y: number;
};

/** @internal */
export const DoubleClickAction$inboundSchema: z.ZodType<
  DoubleClickAction,
  z.ZodTypeDef,
  unknown
> = z.object({
  type: z.literal("double_click"),
  x: z.number().int(),
  y: z.number().int(),
});
/** @internal */
export type DoubleClickAction$Outbound = {
  type: "double_click";
  x: number;
  y: number;
};

/** @internal */
export const DoubleClickAction$outboundSchema: z.ZodType<
  DoubleClickAction$Outbound,
  z.ZodTypeDef,
  DoubleClickAction
> = z.object({
  type: z.literal("double_click"),
  x: z.number().int(),
  y: z.number().int(),
});

export function doubleClickActionToJSON(
  doubleClickAction: DoubleClickAction,
): string {
  return JSON.stringify(
    DoubleClickAction$outboundSchema.parse(doubleClickAction),
  );
}
export function doubleClickActionFromJSON(
  jsonString: string,
): SafeParseResult<DoubleClickAction, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => DoubleClickAction$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DoubleClickAction' from JSON`,
  );
}
